interface slotSchema {
  name: string;        
  label: string;        
  type?: string;     
}